import { useEffect } from "react";
import { api } from "@/lib/api";

const HEARTBEAT_INTERVAL_MS = 30_000; // 30s

/**
 * Sends a periodic heartbeat to the backend so the Owner can see the admin's
 * real-time presence. Pauses automatically when the tab is hidden or offline.
 */
export function useHeartbeat(enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;

    let cancelled = false;

    const beat = async () => {
      if (cancelled) return;
      if (document.visibilityState !== "visible") return;
      if (typeof navigator !== "undefined" && navigator.onLine === false) return;
      try {
        await api.post("/heartbeat");
      } catch (_) {
        /* silent — heartbeat failures shouldn't surface to the user */
      }
    };

    // Immediate ping on mount
    beat();
    const id = setInterval(beat, HEARTBEAT_INTERVAL_MS);

    const onVis = () => {
      if (document.visibilityState === "visible") beat();
    };
    document.addEventListener("visibilitychange", onVis);

    return () => {
      cancelled = true;
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, [enabled]);
}
